import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WpapiService } from 'src/app/services/wpapi.service';
import Player from '@vimeo/player';
@Component({
    selector: 'app-home-reel',
    templateUrl: './home-reel.component.html',
    styleUrls: ['./home-reel.component.scss']
})
export class HomeReelComponent implements OnInit {
    @Input() content: any;
    animateContent: boolean = false;
    iframeIsLoaded: boolean = false;
    dangerousUrl: any;
    video: any;
    player: Player;
    reelgallery: any;
    activeSlide: number = 0;
    interval;
    isNotPaused: boolean = false;
    screenWidth: number = 0;
    @ViewChild('videoplayer') videoplayer: ElementRef;

    constructor(private sanitizer: DomSanitizer) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }
    
    ngOnInit() {
        this.interval = setInterval(() => {
            if (this.isNotPaused) {
                this.callBackSlide();
            }
        }, 6000);
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.animateContent = true;
            if (this.reelgallery === undefined) {
                this.callBackSlide();
            }
            this.reelgallery = this.content.reel_gallery;
        }
    }

    callBackSlide() {
        this.activeSlide = Math.floor(Math.random() * this.content.reel_gallery.length);
    }

    imageLoaded(i) {
        document.getElementById('reel-image-' + i).classList.add('loaded');
    }

    iframeLoaded() {
        this.iframeIsLoaded = true;
    }
}
